import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {useSelector} from "react-redux";
import {BarLoader} from "react-spinners";

const LogsPage = () => {
    const apiKey = useSelector((state) => state.auth.token);
    const [activeTab, setActiveTab] = useState("All")
    const [selectedUser, setSelectedUser] = useState("")
    const [selectedDate, setSelectedDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    })
    const [activities, setActivities] = useState([])
    const [users, setUsers] = useState([])
    const [loadState, setLoadState] = useState(false);
    const navigate = useNavigate()

    const handleNavigation = () => {
        navigate('/', {replace: true});
    };

    const fetchData = async (date) => {
        try {
            const activitiesResponse = await axios.get(
                `${process.env.REACT_APP_BACKEND_EVENT}/users/activities`,
                {
                    params: {date: date},
                    headers: {
                        Authorization: `Bearer ${apiKey}`
                    }
                }
            );


            if (activitiesResponse.data) {
                setActivities(activitiesResponse.data);
                const uniqueUsers = [
                    ...new Set(activitiesResponse.data.map((activity) => activity.username)),
                ];
                setUsers(uniqueUsers);
                setLoadState(false)
            }
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    useEffect(() => {
        if (activities.length === 0) setLoadState(true);

        fetchData(selectedDate); // Initial fetch

        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        console.log(today)
        let interval;
        if (selectedDate === today) {
            interval = setInterval(() => {
                console.log(selectedDate);
                fetchData(selectedDate);
            }, 3000);
        }

        return () => {
            if (interval) clearInterval(interval); // Cleanup interval only if it was set
        };
    }, [selectedDate]); // Depend on selectedDate


    const filterLogs = (logs, type = null, user = selectedUser, date = selectedDate) => {
        return logs.filter((log) => {
            const logDate = log.createdAt.split("T")[0];
            const typeMatches = !type || type.toLowerCase() === "all" || log.type.toLowerCase() === type.toLowerCase();
            const userMatches = !user || log.username.includes(user);
            const dateMatches = !date || logDate === date;
            return typeMatches && userMatches && dateMatches;
        });
    };

    const tabs = [
        {
            name: "All",
            icon: "bi-list",
            filter: () => filterLogs(activities)
        },
        {
            name: "Lead",
            icon: "bi bi-person-bounding-box",
            filter: () => filterLogs(activities, "lead")
        },
        {
            name: "Call",
            icon: "bi-telephone",
            filter: () => filterLogs(activities, "call")
        },
        {
            name: "Status",
            icon: "bi-info-circle",
            filter: () => filterLogs(activities, "status")
        },
        {
            name: "Date",
            icon: "bi-calendar",
            filter: () => filterLogs(activities, "date")
        },
        {
            name: "OneShot",
            icon: "bi bi-cash",
            filter: () => filterLogs(activities, "oneshot")
        },
    ];

    const currentTab = tabs.find(tab => tab.name === activeTab);
    const filteredLogs = currentTab ? currentTab.filter()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')

        if (selectedDate && dateString.startsWith(selectedDate)) {
            return `${hours}:${minutes}`
        }
        return `${month}/${day}/${year} à ${hours}:${minutes}`
    }

    return (
        <div>
            {loadState && (
                <div id="loader">
                    <BarLoader height={4} speedMultiplier={1} width={200}/>
                    {activities.length === 0 && <p>Chargement du logs </p>}
                </div>
            )}
            <div className="container mt-4">
                <div className="d-md-none d-flex mb-3">
                    <button
                        className="btn btn-outline-secondary flex-auto"
                        onClick={handleNavigation}
                    >
                        <i className="bi-arrow-left-circle me-2"></i>Back
                    </button>
                </div>
                <div className="row">
                    <div className="col-md-8 mb-3">
                        <div className="card mb-3 ">
                            <div className="card-header">
                                <ul className="nav nav-tabs card-header-tabs">
                                    {tabs.map((tab) => (
                                        <li className="nav-item" key={tab.name}>
                                            <button
                                                className={`nav-link text-gray-600 ${activeTab === tab.name ? "active" : ""}`}
                                                onClick={() => setActiveTab(tab.name)}
                                            >
                                                <i className={`me-2 ${tab.icon}`}></i>
                                                {tab.name} <span
                                                className="badge bg-gray-400 ms-1">{tab.filter().length}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="card-body">
                                <div
                                    className="bg-dark text-light p-3 rounded"
                                    style={{
                                        height: "300px",
                                        overflowY: "scroll",
                                        fontFamily: "monospace",
                                    }}
                                >
                                    {filteredLogs.length > 0 ? (
                                        filteredLogs.map((log, index) => (
                                            <div key={index} className="mb-2">
                                            <span className="text-success">
                                                {formatDate(log.createdAt)}
                                            </span> -{" "}
                                                <span>{log.activity}</span>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-warning">No logs found for the selected filters.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="card ">
                            <div className="card-header">
                                <i className="bi-funnel me-2"></i>Filter Options
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="userFilter" className="form-label">
                                        Select User
                                    </label>
                                    <select
                                        id="userFilter"
                                        className="form-select"
                                        value={selectedUser}
                                        onChange={(e) => setSelectedUser(e.target.value)}
                                        disabled={activeTab === "Lead"}
                                    >
                                        <option value="">All Users</option>
                                        {users.map((user, index) => (
                                            <option key={index} value={user}>
                                                {user}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3 ">
                                    <label htmlFor="dateFilter" className="form-label">
                                        Select Date
                                    </label>
                                    <input
                                        type="date"
                                        id="dateFilter"
                                        className="form-control"
                                        value={selectedDate}
                                        onChange={(e) => {
                                            setSelectedDate(e.target.value);
                                            setLoadState(true);
                                            fetchData(e.target.value)
                                        }}
                                    />
                                </div>
                                <div className="d-none d-md-flex ">
                                    <button
                                        className="btn btn-outline-secondary flex-auto"
                                        onClick={() => navigate("/")}
                                    >
                                        <i className="bi-arrow-left-circle me-2"></i>Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogsPage;
